import React, { useState } from "react";
import {
	Box,
	Typography,
	Button,
	Paper,
	Rating,
	Snackbar,
	Alert,
	Container,
} from "@mui/material";

const RateTheApp = () => {
	const [value, setValue] = useState(0);
	const [submitted, setSubmitted] = useState(false);
	const [openSnackbar, setOpenSnackbar] = useState(false);

	const handleRateChange = (event, newValue) => {
		setValue(newValue);
	};

	const handleSubmit = () => {
		if (value > 0) {
			// Handle the rating submission logic here
			setSubmitted(true);
			setOpenSnackbar(true);
		}
	};

	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	return (
		<Container
			maxWidth="sm"
			sx={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
			<Paper
				elevation={3}
				sx={{
					p: 4,
					borderRadius: 2,
					width: "100%",
					textAlign: "center",
				}}>
				<Typography variant="h4" gutterBottom>
					Enjoying Our App?
				</Typography>
				<Typography variant="subtitle1" color="textSecondary" mb={3}>
					Please rate your experience and help us improve!
				</Typography>
				<Rating
					name="app-rating"
					value={value}
					onChange={handleRateChange}
					precision={0.5}
					size="large"
				/>
				<Box mt={4}>
					<Button
						variant="contained"
						color="primary"
						size="large"
						disabled={value === 0}
						onClick={handleSubmit}
						sx={{ px: 4, py: 1.5, borderRadius: 3 }}>
						Submit
					</Button>
				</Box>

				{/* Optional: Show thank you message after submission */}
				{submitted && (
					<Typography variant="h6" color="success.main" mt={3}>
						Thank you for your feedback!
					</Typography>
				)}

				{/* Snackbar for feedback */}
				<Snackbar
					open={openSnackbar}
					autoHideDuration={3000}
					onClose={handleCloseSnackbar}>
					<Alert
						onClose={handleCloseSnackbar}
						severity="success"
						sx={{ width: "100%" }}>
						Your rating has been submitted!
					</Alert>
				</Snackbar>
			</Paper>
		</Container>
	);
};

export default RateTheApp;
